import React from 'react';
import { CheckboxContainer, StyledLabel } from './styled.checkbox';
import { Checked } from '../../icons/Checked';
import { NotChecked } from '../../icons/NotChecked';
import { ICheckbox } from '../../../@types/checkbox';

export function Checkbox ({label, onClick, checked, disabled}: ICheckbox) {

  if (disabled) {
    return (
      <CheckboxContainer>
        <Checked opacity={0.5} />
        <StyledLabel>{label}</StyledLabel>
      </CheckboxContainer>
    );
  }

  return (
    <CheckboxContainer onClick={onClick}>
      {checked ? <Checked /> : <NotChecked />}
      <StyledLabel>{label}</StyledLabel>
    </CheckboxContainer>
  );
}
